import { render, staticRenderFns } from "./limitarearemindset.vue?vue&type=template&id=4211121a"
import script from "./limitarearemindset.vue?vue&type=script&lang=js"
export * from "./limitarearemindset.vue?vue&type=script&lang=js"
import style0 from "./limitarearemindset.vue?vue&type=style&index=0&id=4211121a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports